module.exports = __webpack_public_path__ + "static/media/12.094a3e09.jpg";